<!-- 表二列表 -->

<template>
  <div class="tabCage table2">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 1-3：音像制品出版情况登记表</span>
      <span v-else>表 1-3：电子出版物出版情况登记表</span>
      <div class="tabBtns">
        <el-button type="primary" @click="memberEdit(1)" size="mini">添加</el-button>
        <el-button size="mini">返回</el-button>
      </div>
    </div>
    <div class="ctrlsLine">
      <el-radio-group v-model="yearSet" @change="tabSeek">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">2017年</el-radio>
        <el-radio :label="2">2018年</el-radio>
      </el-radio-group>
      <el-input v-model="seekPms.keyword" size="small"></el-input>
      <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
      <el-button class="dangerBtns" size="small" @click="memberDet(1)" type="warning">删除</el-button>
      <el-button class="dangerBtns" @click="memberClean" size="small" type="danger">清除全部</el-button>
    </div>

    <div class="tabForms">
      <el-table :data="tabDat" border style="width: 100%" @selection-change="selectionChange" v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="year" label="年份" width="90" align="center"> </el-table-column>
        <el-table-column prop="publicationName" label="出版物名称" width="180" align="center"> </el-table-column>

        <el-table-column prop="isbn" width="150" label="专用书号(ISBN 978-7-)" align="center"> </el-table-column>
        <el-table-column label="载体形式" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.carrierForm | translate("C010", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="出版形式" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.publicationForm | translate("C011", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="productionUnit" label="节目来源/制作单位" width="90" align="center"> </el-table-column>
        <el-table-column prop="programCapacity" label="节目时长或容量(分钟/兆)" width="90" align="center">
        </el-table-column>
        <el-table-column prop="publicationQuantity" label="出版数量（张/盒）" width="90" align="center">
        </el-table-column>
        <el-table-column prop="IssueQuantity" label="发行数量（张/盒）" width="90" align="center"> </el-table-column>
        <el-table-column prop="unitPrice" label="发行单价（元）" width="90" align="center"> </el-table-column>
        <el-table-column prop="publishingTime" label="出版时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishingTime | stringTrans("time") }}
          </template>
        </el-table-column>
        <el-table-column label="是否缴送样本" align="center">
          <template slot-scope="scope">
            {{ scope.row.sampleDelivery | translate("C018", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="是否书配盘标记" align="center">
          <template slot-scope="scope">
            {{ scope.row.sign | translate("C018", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="memberEdit(2, scope.row)" size="mini">编辑</el-button>
            <el-button type="danger" @click="memberDet(2, scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { tabList3, tab3Remove, tab3Clean } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15,
      },
    };
  },
  filters: {
    translate: function (dat, code, transMap) {
      return transMap[code][dat];
    },
    stringTrans: function (dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    },
  },
  methods: {
    tabSeek: function (type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      let nowYear = new Date().getFullYear();

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = nowYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = nowYear - 1;
      }

      tabList3(this.seekPms).then((response) => {
        let vm = this;
        setTimeout(function () {
          vm.tabDat = response.ppublicationList;
          vm.loading = false;
        }, 300);
      });
    },
    memberDet: function (type, dat) {
      let params = {};
      let message = '确定删除出版物 "' + dat.publicationName + '" 的在库信息吗？';

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确定删除所有选中人员的在库信息吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        params.publishMaterialId = this.$route.query.mtId;
        tab3Remove(params)
          .then((response) => {
            this.tabSeek();
          })
          .catch((error) => {});
      });
    },
    memberClean: function () {
      this.$confirm("此操作会删除所有已录入数据库的出版物信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tab3Clean().then((response) => {
            this.tabSeek();
          });
        })
        .catch(() => {});
    },
    selectionChange: function (selection) {
      let newArr = [];
      for (let i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function () {
      let nameArr = ["C010", "C011", "C018"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    memberEdit: function (type, dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.replace({
        path: "edit_tab3",
        query: pathParams,
      });
    },
  },
  created: function () {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  },
};
</script>

<style>
.tabCage {
  position: relative;
  color: #666666;
  padding: 20px;
  font-size: 14px;
}

.tabBtns {
  float: right;
}

.tabBtns .el-button {
  /* width: 90px; */
  margin-top: -6px;
}

.tabTtl {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  padding: 0px 20px;
  border-bottom: 1px solid #f8f8f8;
  padding-bottom: 18px;
}

.ctrlsLine {
  padding: 20px;
}

.ctrlsLine .el-radio__label {
  margin-left: -5px;
}

.ctrlsLine .el-input {
  display: inline-block;
  width: 360px;
  margin-left: 20px;
}

.ctrlsLine .el-input input {
  border-radius: 0px;
}

.dangerBtns {
  width: 80px;
}

.ctrlsLine .el-button + .el-button {
  margin-left: 0px;
}

.seekBtn {
  margin-right: 20px;
}

.ctrlsLine .el-radio + .el-radio {
  margin-left: 20px;
}

.tabForms {
  padding: 0px 20px;
  position: relative;
}

.tabForms .el-button + .el-button {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// table3.vue?f326fb9e